import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getAudit = () => axios.get(`${API}/audit`).then((r) => r.data);
export const createAudit = (payload) =>
  axios.post(`${API}/audit`, payload).then((r) => r.data);
export const getKeys = () => axios.get(`${API}/keys`).then((r) => r.data);
export const verifyAudit = (id) =>
  axios.get(`${API}/audit/${id}/verify`).then((r) => r.data);
export const tamperAudit = (id) =>
  axios.post(`${API}/audit/${id}/tamper`).then((r) => r.data);
export const exportLedgerJson = () =>
  axios.get(`${API}/audit/export?fmt=json`).then((r) => r.data);
export const csvExportUrl = () => `${API}/audit/export?fmt=csv`;

export const getLibrary = () => axios.get(`${API}/library`).then((r) => r.data);
export const createLibrary = (payload) =>
  axios.post(`${API}/library`, payload).then((r) => r.data);
export const deleteLibrary = (id) =>
  axios.delete(`${API}/library/${id}`).then((r) => r.data);
export const exportLibraryEntry = (id) =>
  axios.get(`${API}/library/${id}/export`).then((r) => r.data);
export const clearAudit = () => axios.delete(`${API}/audit`).then((r) => r.data);
